import { defineComponent, ref, computed, h } from 'vue-demi'
import './style.scss'
const classPrefix = `rich-selector`

const SelectorView = defineComponent({
  name: 'SelectorView',
  props: {
    multiple: { default: false },
    defaultValue: {},
    value: {},
    columns: {},
    options: { default: () => [] },
    disabled: { default: false }
  },
  setup(props, { emit }) {
    const selfValue = ref(props.defaultValue || props.value || [])

    const model = computed({
      get() {
        return props.value || selfValue.value
      },
      set(val) {
        emit('input', val)
        emit('change', val)
        selfValue.value = val
      }
    })

    return () => {
      const items = props.options.map(option => {
        const active = (model.value || []).includes(option.value)
        const disabled = option.disabled || props.disabled
        const itemCls = {
          [`${classPrefix}-item`]: true,
          [`${classPrefix}-item-active`]: active && !props.multiple,
          [`${classPrefix}-item-multiple-active`]: active && props.multiple,
          [`${classPrefix}-item-disabled`]: disabled
        }

        return h(
          'div',
          {
            props: {
              key: option.value
            },
            class: [itemCls],
            on: {
              click() {
                if (disabled) {
                  return
                }
                if (props.multiple) {
                  const val = active
                    ? model.value.filter(v => v !== option.value)
                    : [...model.value, option.value]
                  model.value = val
                  emit('item-click', option.value, val)
                } else {
                  const val = active ? [] : [option.value]
                  model.value = val
                  emit('item-click', option.value, val)
                }
              }
            }
          },
          [option.label]
        )
      })

      return h(
        'div',
        {
          class: [classPrefix]
        },
        !props.columns
          ? [h('div', { props: {}, class: 'rich-space' }, [items])]
          : [
            h(
              'div',
              {
                props: {},
                style: {
                  '--columns': props.columns,
                  '--gap': '8px'
                },
                class: 'rich-grid'
              },
              [items]
            )
          ]
      )
    }
  }
})

export default SelectorView
